<script>
import mixin from "@/pages/inspection_reports/forms/mixin";

export default {
	mixins: [mixin],
	methods: {
		getGroups() {
			return [
				{
          'title': 'Algemene gegevens',
					'name': 'product',
					'component': 'default',
					'values': {
						'product_manufacturer': this.input({type: 'Default', label: 'Fabrikaat:', value: this.getValue('product_manufacturer', this.customerProduct.product.manufacture.name)}),
						'product_type': this.input({type: 'Default', label: 'Type:', value: this.getValue('product_type', this.customerProduct.product.type.name)}),
            'product_serie_nr': this.input({type: 'Default', label: 'Serienr.', value: this.getValue('product_serie_nr', this.customerProduct.product.serial_number)}),
						'product_toelatingsnr': this.input({type: 'Default', label: 'Toelatingsnr:', value: this.getValue('product_toelatingsnr', this.customerProduct.product.type_approval_number)}),
						'product_meetbereik': this.input({type: 'Default', label: 'Meetbereik', value: this.getValue('product_meetbereik', '0 - 1000 N')}),
					}
				},
				{
					'title': 'Plaats van opstelling',
					'name': 'customer',
          'component': 'hidden',
					'values': {
						'customer_naam': this.input({type: 'Default', label: 'Naam', value: this.getValue('customer_naam', this.customerProduct.customer.name)}),
						'customer_adres': this.input({type: 'Default', label: 'Adres', value: this.getValue('customer_adres', this.customerProduct.customer.address)}),
						'customer_plaats': this.input({type: 'Default', label: 'Plaats', value: this.getValue('customer_plaats', this.customerProduct.customer.city)}),
					}
				},
				{
					'title': 'Conformiteit',
					'name': 'conformiteit',
					'component': 'default',
					'values': {
						'conformiteit_verzegeling_onbeschadigd': this.input({type: 'YesNo', label: 'Verzegeling onbeschadigd', value: this.getValue('conformiteit_verzegeling_onbeschadigd')}),
						'conformiteit_typekeuringscert': this.input({type: 'YesNo', label: 'Typekeuringscert. met bijlage + doc. aanw.', value: this.getValue('conformiteit_typekeuringscert')}),
						'conformiteit_merk': this.input({type: 'YesNo', label: 'Merk en type krachtopnemer', value: this.getValue('conformiteit_merk')}),
						'conformiteit_aanwezige_printplaten': this.input({type: 'YesNo', label: 'Aanwezige printplaten', value: this.getValue('conformiteit_aanwezige_printplaten')}),
						'conformiteit_software_versie': this.input({type: 'YesNo', label: `Softwareversie : ${this.softwareVersion}`, value: this.getValue('conformiteit_software_versie')}),
						'conformiteit_checksum': this.input({type: 'YesNo', label: `Checksum : ${this.checksum}`, value: this.getValue('conformiteit_checksum')}),
					}
				},
				{
					'title': 'Algemeen',
					'name': 'common',
					'component': 'default',
					'values': {
						'common_omgevingstemperatuur': this.input({type: 'YesNo', label: 'Omgevingstemperatuur', value: this.getValue('common_omgevingstemperatuur')}),
						'common_nl_handleiding': this.input({type: 'YesNo', label: 'NL handleiding en NL opschriften', value: this.getValue('common_nl_handleiding')}),
						'common_voedingsspanning': this.input({type: 'YesNo', label: 'Voedingsspanning', value: this.getValue('common_voedingsspanning')}),
						'common_electronische_mechanische_werking': this.input({type: 'YesNo', label: 'Electronische / mechanische werking', value: this.getValue('common_electronische_mechanische_werking')}),
						'common_optische_controle': this.input({type: 'YesNo', label: 'Optische controle krachtopn. / snoer', value: this.getValue('common_optische_controle')}),
					}
				},
				{
					'title': 'Pedaalkrachtmetertest',
					'name': 'pedaalkrachtmetertest',
					'component': 'pedaalkracht',
					'values': {
            'pedaalkrachtmetertest_0_n_forwards' : this.input({label: '0', value: this.getValue('pedaalkrachtmetertest_0_n_forwards'), testValue: 0}),
            'pedaalkrachtmetertest_200_n_forwards' : this.input({label: '200', value: this.getValue('pedaalkrachtmetertest_200_n_forwards'), testValue: 200}),
            'pedaalkrachtmetertest_400_n_forwards' : this.input({label: '400', value: this.getValue('pedaalkrachtmetertest_400_n_forwards'), testValue: 400}),
            'pedaalkrachtmetertest_600_n_forwards' : this.input({label: '600', value: this.getValue('pedaalkrachtmetertest_600_n_forwards'), testValue: 600}),
            'pedaalkrachtmetertest_800_n_forwards' : this.input({label: '800', value: this.getValue('pedaalkrachtmetertest_800_n_forwards'), testValue: 800}),
            'pedaalkrachtmetertest_700_n_backwards' : this.input({label: '700', value: this.getValue('pedaalkrachtmetertest_700_n_backwards'), testValue: 700}),
            'pedaalkrachtmetertest_500_n_backwards' : this.input({label: '500', value: this.getValue('pedaalkrachtmetertest_500_n_backwards'), testValue: 500}),
            'pedaalkrachtmetertest_300_n_backwards' : this.input({label: '300', value: this.getValue('pedaalkrachtmetertest_300_n_backwards'), testValue: 300}),
            'pedaalkrachtmetertest_100_n_backwards' : this.input({label: '100', value: this.getValue('pedaalkrachtmetertest_100_n_backwards'), testValue: 100}),
            'pedaalkrachtmetertest_0_n_backwards' : this.input({label: '0', value: this.getValue('pedaalkrachtmetertest_0_n_backwards'), testValue: 0}),
          },
				},
        {
          'title': 'Excentrischtest',
          'name': 'excentrischtest',
          'component': 'exentric',
          'values': {
            'excentrischtest_200_<': this.input({label: '200 <', value: this.getValue('excentrischtest_200_<'), testValue: 200}),
            'excentrischtest_200_^': this.input({label: '200 ^', value: this.getValue('excentrischtest_200_^'), testValue: 200}),
            'excentrischtest_200_>': this.input({label: '200 >', value: this.getValue('excentrischtest_200_>'), testValue: 200}),
            'excentrischtest_200_v': this.input({label: '200 v', value: this.getValue('excentrischtest_200_v'), testValue: 200}),
          },
        },
				{
					'name': 'slot',
					'component': 'default',
					'values': {
						'slot_notes': this.input({type: 'textarea', label: 'Opmerkingen', value: this.getValue('common_notes')}),
					}
				}
			]
		}
	}
}
</script>

<template>
	<FormRenderer
		ref="renderer"
		:inspectionReport="inspectionReport"
		:inspectionReportResponse="inspectionReportResponse"
		:customerProduct="customerProduct"
		:appointmentId="appointmentId"
	/>
</template>